import { monitor_table_datetime_ajax, monitor_table_ajax, reconstruct_alert_content } from "@/utils/monitor/monitor.js"
import { mapState, mapGetters, mapMutations } from 'vuex'

export const monitor_mixin = {
    data() {
        return {
            date: null,
            time: null,
            is_newest_data: true,
            interval_func: '',

            change_time: ''
        }
    },

    computed: {
        ...mapState('monitor', [
            'is_monitor'
        ]),

        ...mapState('emap-monitor', [
            'is_monitor_open_emap',
            'monitor_alert'
        ]),

        ...mapGetters('case', [
            'is_case_mode'
        ]),
        
        auto_update() {
            // 視窗在 monitor 且是最新資料，且不是在個案中
            return this.is_monitor && this.is_newest_data && !this.is_case_mode
        }
    },

    watch: {
        auto_update: {
            immediate: true,
            handler() {
                this.update_timer_contorller()
            },
        },

        change_time() {
            if (this.is_monitor_open_emap) {
                // 監控地圖，當時間改變後，改變項次對應燈號的表
                // 與 map_display_switch 組件關聯
                this.monitor_alert.alert_content = reconstruct_alert_content(this.immutable_table_data);
                this.set_monitor_alert(this.monitor_alert);
            }
        }
    },

    beforeDestroy() {
        this.clear_update_interval();
    },

    
    methods: {
        ...mapMutations('emap-monitor', [
            'set_monitor_alert'
        ]),

        async update_time(new_datetime) {
            this.is_newest_data = false
            await monitor_table_ajax.call(this, this.default_value, new_datetime)
            this.change_time = new_datetime
        },

        update_timer_contorller() {
            if(this.auto_update && !this.interval_func) {
                this.interval_func = setInterval(() => {
                    monitor_table_datetime_ajax.call(this, this.default_value);
                }, 60000);
            } else {
                this.clear_update_interval()
            }
        },

        clear_update_interval() {
            clearInterval(this.interval_func)
            this.interval_func = ''
        },

        change_parent_date_time(date, time) {
            // qpe_datatable 裡面的 diagram dialog 是必須從父元件透過 slot 傳下去，所以元件使用的時間來自父元件，
            // 因此更改qpe_datatable 的時間時，要一併將父元件的時間修改。
            this.date = date
            this.time = time
        }
    }
}
